module.exports = __webpack_public_path__ + "img/2011-1.fa33b485.jpeg";